export default {
  OrderManagement: "订单管理",
  Conversation: "对话管理",
  Config: "配置管理",
  Service: "客服管理",
  Label: "标签管理",
  System: "系统管理",
  SystemUsers: "用户管理",
  SystemAuth: "菜单管理",
  SystemDept: "部门管理",
  SystemRoles: "角色管理",
  SystemOnlineLog: "在线日志",
  Report: "报告",
  PersonalCenter: "个人中心",
  QuickReply: "快捷回复",
  statement: "报表统计",
};
